<template lang="pug" src="./template.pug">
</template>
<style scoped lang="scss" src="./style.scss"></style>

<script>
import utils from "utils/js/utils";
import bus from "utils/js/bus";
export default {
  name: "Home",
  props: {
    msg: String,
  },
  methods:{
    goto(page, anchor){
      this.$router.push({path:page, query:{anchor:anchor}});
    }
  },
  mounted() {
    utils.startLoading(".home", () => {
      bus.$emit("showLoading", false);
      if (this.$route.query.anchor) {
        const anchor = this.$route.query.anchor;
        if ($(`section.${anchor}`).length==1) {
          setTimeout(()=>{
            utils.scrollTo(`section.${this.$route.query.anchor}`)
          }, 400)
        }
      }
    });
  },
};
</script>
